import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { LoadingButton } from 'base-ui'

import { useUserApiSwrSessionV1Customer } from '../../../../../user-data'

import { ProductOutOfStockReminderButtonTooltipLoginRequired } from './ButtonTooltipLoginRequired'
import { ProductOutOfStockSendReminderSubscribeButton } from './ProductOutOfStockSendReminderSubscribeButton/ProductOutOfStockSendReminderSubscribeButton'

export const ProductOutOfStockSendReminder: FC = () => {
  const sessionSwr = useUserApiSwrSessionV1Customer()
  const intl = useIntl()

  const isLoggedIn = Boolean(sessionSwr.data?.customerNumber)

  if (sessionSwr.isLoading || sessionSwr.error) {
    return (
      <LoadingButton
        aria-label={intl.formatMessage({ id: 'button.loading.label' })}
        className="mb-2.5 w-full"
        loading
      />
    )
  }

  return isLoggedIn ? (
    <ProductOutOfStockSendReminderSubscribeButton />
  ) : (
    <ProductOutOfStockReminderButtonTooltipLoginRequired />
  )
}
